<template>
  <div>
    <a-menu v-model="current" mode="horizontal">
      <a-menu-item key="Warning">{{ $t('warning.device') }} </a-menu-item>
      <a-menu-item key="MultipleWarning">{{ $t('warning.multiple') }} </a-menu-item>
    </a-menu>
    <component :is="current[0]" />
  </div>
</template>

<script>
import Warning from '../Warning.vue'
import MultipleWarning from '../../EquipmentGroupPreview/SetWarning/components/MultipleWarning.vue'

export default {
  components: {
    Warning,
    MultipleWarning
  },
  created() {
    let a = this.getAuthorities('/equipment/group')
    this.isMutipleShow = !!a.find(auth => auth.code === "warning:custom:query")
  },
  data() {
    return {
      current: ['Warning'],
      isMutipleShow: false
    }
  }
}
</script>

<style>

</style>